import request from "@/utils/request";
import Cookies from "js-cookie";

let language = Cookies.get("language") ? Cookies.get("language") : "en_GB";

import md5 from "js-md5";
// 用户登录
export function webUserLogin(data) {
  return request({
    url: `webUser/webUserLogin`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
}

// 注册
export function webUserRegister(data) {
  return request({
    url: `webUser/webUserRegister`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

// 修改用户信息
export function updateUserInfo(data) {
  return request({
    url: `user/updateUserInfo/${language}`,
    method: "post",
    data: {
      mailbox: data.mailbox,
      userName: data.userName,
      password: md5(
        "88*&6AKcsgskcsbdjhfvjSDFSDGjbhsdj%)(((jdhgsf!" + data.password
      ).toUpperCase(),
    },
  });
}

//二级分类标题
export function productCategoryPojoNoPage(data) {
  return request({
    url: `webProductCategory/web/productCategoryPojoNoPage`,
    method: "get",
    params: data,
  });
}

export function webUserLogout(data) {
  return request({
    url: `webUser/webUserLogout`,
    method: "post",
    data: data,
  });
}

// 发送验证码
export function webUserSendEmail(data) {
  return request({
    url: `webUser/webUserSendEmail`,
    method: "get",
    params: data,
  });
}

// 验证验证码
export function webUserCheckCode(data) {
  return request({
    url: `webUser/webUserCheckCode`,
    method: "post",
    data: data,
  });
}

// 修改密码
export function webUserUpdatePassword(data) {
  return request({
    url: `webUser/webUserUpdatePassword`,
    method: "post",
    data: data,
  });
}

// 获取用户信息
export function webUserGetUserInfo(data) {
  return request({
    url: `webUser/getUserInfo`,
    method: "get",
    params: data,
  });
}


//获取购物车数量
export function productShoppingCartNumber() {
  return request({
    url: `productShoppingCart/web/productShoppingCartNumber`,
    method: "get",
  });
}
